module.exports = __webpack_public_path__ + "static/media/lol-challanger.001311d0.png";